export default function LibraryCard({ name, memberNumber, since }) {
  return (
    <div
      data-testid="library-card"
      className="bg-[#111111] text-white w-full max-w-md mx-auto p-8 border-2 border-[#3A3A3A] flex flex-col justify-between"
      style={{ aspectRatio: "1.58 / 1", minHeight: 280 }}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="font-ui text-[9px] tracking-[0.3em] uppercase text-[#DCDCDC]">The People's</div>
          <div className="font-headline text-2xl leading-none mt-1">Archive Library</div>
        </div>
        <div className="font-ui text-[9px] tracking-[0.3em] uppercase text-[#DCDCDC] text-right">
          Member<br />Card
        </div>
      </div>

      <div>
        <div className="font-ui text-[9px] tracking-[0.3em] uppercase text-[#6C6C6C] mb-1">Cardholder</div>
        <div className="font-headline text-xl md:text-2xl leading-tight" data-testid="card-name">{name || "—"}</div>
      </div>

      <div className="flex items-end justify-between gap-6">
        <div className="flex-1">
          <div className="barcode" />
          <div className="font-ui text-[10px] tracking-[0.25em] mt-2 text-[#DCDCDC]" data-testid="card-number">
            {memberNumber || "PA-XXXX-XXXXXX"}
          </div>
        </div>
        <div className="text-right">
          <div className="font-ui text-[9px] tracking-[0.3em] uppercase text-[#6C6C6C]">Member Since</div>
          <div className="font-headline text-lg" data-testid="card-since">{since || "—"}</div>
        </div>
      </div>
    </div>
  );
}
